import CampaignPicturesApp from 'campaign/components/campaignDocuments/CampaignPicturesApp'
import React from 'react'

const PluviometryCampaignPicturesApp = () => (
    <CampaignPicturesApp stationType='pluviometry' />
)

export default PluviometryCampaignPicturesApp
